import { Suspense, useEffect, useState, useContext } from "react";
import { DataContext } from "../../context/data-provider";
import { Dna } from "react-loader-spinner";
import MonthCalendarCustom from "../elements/MonthCalendarCustom";
import {
    Box,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    Button,
    Divider,
    TextField,
} from "@mui/material";
import { NationalHolidaysInterface } from "../../interface/nationalHolidayInterface";
import axiosInstance from "../../services/axios-instance";
import {
    All_USERS_URL,
    HOLIDAYS_REQUESTS_URL,
    NATIONAL_HOLIDAYS_URL,
    SELECTED_USER_ID_URL,
    HOLIDAY_TYPES_URL,
    HOLIDAYS_URL,
    NATIONAL_HOLIDAYS_WEEKLY,
} from "../../services/endpoints";
import { AllUsersInterface } from "../../interface/allUsersInterface";
import { UserInterface } from "../../interface/userInterface";
import DaysCard from "../elements/DaysCard";
import { Circle } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import RequestDaysCard from "../elements/RequestDaysCard";
import RequestDaysComponent from "../elements/RequestDaysComponent";
import { styled } from "@mui/material/styles";
import { DateObject } from "react-multi-date-picker";
import { ROLES } from "../../assets/data/roles";

const RequestDaysForm = styled(Box)(({ theme }) => ({
    margin: 8,
    width: "52ch",
    height: "3.4rem",
    borderRadius: 4,
    border: `1px solid ${theme.palette.grey[400]}`,

    [theme.breakpoints.down("sm")]: {
        width: "25ch",
    },
}));

interface MonthDataParams {
    confirming_id: number;
    created_at: string;
    from_date: string;
    id: number;
    notes: string;
    requesting_id: number;
    status: number;
    to_date: string;
    type: number;
}

const Holidays = () => {
    const [requestDays, setRequestDays] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [dateValue, setDateValue] = useState<DateObject[]>([]);
    const [approvalName, setApprovalName] = useState("");
    const [approvalDate, setApprovalDate] = useState("");
    const [approvalVia, setApprovalVia] = useState("");
    const [formError, setFormError] = useState("");
    const [isWide, setIsWide] = useState(window.innerWidth > 600);
    const [totalHolidays, setTotalHolidays] = useState(0);

    const [nationalHolidays, setNationalHolidays] = useState<
        NationalHolidaysInterface[]
    >([]);
    const [allListOfHolidays, setAllListOfHolidays] = useState<
        MonthDataParams[]
    >([]);
    const [users, setUsers] = useState<AllUsersInterface[]>([]);
    const { currentUser } = useContext(DataContext);
    const [selectedUser, setSelectedUser] = useState<number | "">("");

    const [selectedRequestingUserId, setSelectedRequestingUserId] = useState(
        currentUser.id,
    );

    const [holidayTypes, setHolidayTypes] = useState({});
    const [currentSelectedUser, setCurrentSelectedUser] =
        useState<UserInterface>({
            id: null,
            name: "",
            email: "",
            role_id: 0,
            available_days: 0,
            available_days_left: 0,
            available_days_current: 0,
            available_days_left_all: 0,
            available_days_left_current: 0,
            available_days_prev: 0,
            available_days_left_prev: 0,
            available_days_next: 0,
            available_days_left_next: 0,
            clients: [],
        });

    const theme = useTheme();

    function extractDates(dateValue: DateObject[]) {
        const selectedDates = dateValue.toString();
        return {
            fromDate: selectedDates.split(",")[0],
            toDate: selectedDates.split(",")[1],
        };
    }

    function calculateDays(start: string, end: string) {
        const startDate = new Date(start);
        const endDate = new Date(end);
        // Calculate total days
        const totalDays =
            Math.floor(
                (endDate.getTime() - startDate.getTime()) /
                    (1000 * 60 * 60 * 24),
            ) + 1;

        let weekendDays = 0;

        for (
            let d = new Date(startDate);
            d <= endDate;
            d.setDate(d.getDate() + 1)
        ) {
            if (d.getDay() === 0 || d.getDay() === 6) {
                // Sunday = 0, Saturday = 6
                weekendDays++;
            }
        }

        const weekdays = totalDays - weekendDays;

        return { totalDays, weekdays };
    }

    const { fromDate, toDate } = extractDates(dateValue);
    const { totalDays, weekdays } = calculateDays(fromDate, toDate);

    const notes =
        approvalName && approvalDate
            ? `The leave is approved by ${approvalName} on the date ${approvalDate} via ${approvalVia}.`
            : "";

    const formRequestHoliday = {
        notes: notes === "" ? "There are no notes added" : notes,
        from_date: fromDate,
        to_date: toDate,
        confirming_id: "37",
        requesting_id:
            currentUser.role_id == ROLES.ADMIN
                ? selectedRequestingUserId
                : currentUser.id,
        type: selectedOption,
    };

    const onChangeDateValue = (event: DateObject[]) => {
        setDateValue(event);
    };

    const handleOptionChange = (event: {
        target: { value: React.SetStateAction<string> };
    }) => {
        setSelectedOption(event.target.value);
    };

    const requestApprover = "Sonja"; // conforming id

    useEffect(() => {
        const handleResize = () => {
            setIsWide(window.innerWidth > 600);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await axiosInstance.get(
                    NATIONAL_HOLIDAYS_WEEKLY,
                    {
                        params: {
                            from: fromDate,
                            to: toDate,
                        },
                    },
                );
                setTotalHolidays(response.data.length);
            } catch (error) {
                console.error(error);
            }
        }
        if (fromDate && toDate) fetchData();
    }, [fromDate, toDate]);

    useEffect(() => {
        async function fetchData() {
            try {
                const responseHolidaysTypes =
                    await axiosInstance.get(HOLIDAY_TYPES_URL);

                const responseAllUsers = await axiosInstance.get(All_USERS_URL);

                if (currentSelectedUser.id) {
                    const responseHolidaysRequests = await axiosInstance.get(
                        HOLIDAYS_REQUESTS_URL(currentSelectedUser.id),
                    );

                    setAllListOfHolidays(responseHolidaysRequests.data.data);
                }

                const responseNatinalHolidays = await axiosInstance.get(
                    NATIONAL_HOLIDAYS_URL,
                );

                setNationalHolidays(responseNatinalHolidays.data.data);
                setUsers(responseAllUsers.data.data);
                setHolidayTypes(responseHolidaysTypes.data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [currentSelectedUser.id, selectedUser]);

    useEffect(() => {
        async function getUser() {
            if (currentUser.id) {
                const responseUserID = await axiosInstance.get(
                    SELECTED_USER_ID_URL(+currentUser.id),
                );
                setCurrentSelectedUser(responseUserID.data.data);
                setSelectedUser(currentUser.id);
            }
        }
        getUser();
    }, [currentUser.id]);
    return (
        <>
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "left",
                    flexWrap: {
                        xs: "wrap",
                        lg: "nowrap",
                    },
                    gap: 2,
                }}
            >
                {currentUser.role_id != null &&
                [0, 1].includes(+currentUser.role_id) &&
                !requestDays ? (
                    <Grid
                        item
                        sx={{
                            display: {
                                sm: "flex",
                                xl: "block",
                            },
                            alignItems: "center",
                            mt: {
                                sm: -1,
                                xl: 0,
                            },
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                marginBottom: "12px",
                                marginLeft: "8px",
                                fontSize: {
                                    xs: "0.9rem",
                                    xl: "1.25rem",
                                },
                            }}
                        >
                            Select user to view holidays.
                        </Typography>

                        <FormControl
                            style={{
                                marginBottom: "12px",
                                marginLeft: "8px",
                            }}
                        >
                            <InputLabel shrink id="user-select-label">
                                Select User
                            </InputLabel>
                            <Select
                                labelId="user-select-label"
                                label="Select User"
                                id="user-select"
                                value={selectedUser}
                                onChange={async (e) => {
                                    if (e.target.value) {
                                        setSelectedUser(+e.target.value);
                                        const responseUserID =
                                            await axiosInstance.get(
                                                SELECTED_USER_ID_URL(
                                                    +e.target.value,
                                                ),
                                            );

                                        setCurrentSelectedUser(
                                            responseUserID.data.data,
                                        );
                                    }
                                }}
                                style={{ minWidth: "200px" }}
                            >
                                {users.map((user) => (
                                    <MenuItem key={user.id} value={user.id}>
                                        {user.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                ) : (
                    ""
                )}
                <Grid item>
                    <Box sx={{ display: "flex" }}>
                        <DaysCard
                            cardColor={theme.palette.grey[50]}
                            cardType="daysWaiting"
                            totalHolidays={
                                currentSelectedUser?.available_days_prev
                            }
                            daysAvailable={
                                currentSelectedUser?.available_days_left_prev
                            }
                            thisYear={new Date().getFullYear() - 1}
                        />
                        <DaysCard
                            cardColor={theme.palette.grey[50]}
                            cardType="daysWaiting"
                            totalHolidays={
                                currentSelectedUser?.available_days_current
                            }
                            daysAvailable={
                                currentSelectedUser?.available_days_left_current
                            }
                            thisYear={new Date().getFullYear()}
                        />
                        <DaysCard
                            cardColor={theme.palette.grey[50]}
                            cardType="daysWaiting"
                            totalHolidays={
                                currentSelectedUser?.available_days_next
                            }
                            daysAvailable={
                                currentSelectedUser?.available_days_left_next
                            }
                            thisYear={new Date().getFullYear() + 1}
                        />
                        <DaysCard
                            cardColor={theme.palette.grey[50]}
                            cardType="daysApproved"
                            daysAvailable={
                                currentSelectedUser?.available_days_left_all
                            }
                        />
                    </Box>
                </Grid>
                <Grid item>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: {
                                xs: "start",
                                md: "center",
                            },
                            alignItems: "center",
                        }}
                    >
                        {!requestDays && (
                            <Button
                                variant="contained"
                                color="error"
                                sx={{
                                    textTransform: "none",
                                    fontWeight: "600",
                                }}
                                onClick={() => setRequestDays(!requestDays)}
                            >
                                Request Holiday
                            </Button>
                        )}
                    </Box>
                </Grid>
                <Grid
                    sx={{
                        marginLeft: "auto",
                    }}
                    item
                >
                    <Box
                        sx={{
                            display: "flex",
                            gap: 3,
                            justifyContent: "center",
                            msWrap: "wrap",
                            mt: {
                                xl: 2,
                            },
                        }}
                    >
                        <Box
                            component={"p"}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                    xs: "0.8rem",
                                    xl: "1rem",
                                },
                            }}
                        >
                            <Circle
                                sx={{
                                    paddingRight: "5px",
                                    "&.MuiSvgIcon-root": {
                                        color: "holiday.pending",
                                    },
                                }}
                            />
                            Pending
                        </Box>
                        <Box
                            component={"p"}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                    xs: "0.8rem",
                                    xl: "1rem",
                                },
                            }}
                        >
                            <Circle
                                sx={{
                                    paddingRight: "5px",
                                    "&.MuiSvgIcon-root": {
                                        color: "holiday.approved",
                                    },
                                }}
                            />
                            Approved
                        </Box>
                        <Box
                            component={"p"}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                    xs: "0.8rem",
                                    xl: "1rem",
                                },
                            }}
                        >
                            <Circle
                                sx={{
                                    paddingRight: "5px",
                                    "&.MuiSvgIcon-root": {
                                        color: "holiday.sickLeave",
                                    },
                                }}
                            />
                            Sick Leave
                        </Box>
                        <Box
                            component={"p"}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                    xs: "0.8rem",
                                    xl: "1rem",
                                },
                            }}
                        >
                            <Circle
                                sx={{
                                    paddingRight: "5px",
                                    "&.MuiSvgIcon-root": {
                                        color: "holiday.rejected",
                                    },
                                }}
                            />
                            Declined
                        </Box>
                        <Box
                            component={"p"}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                    xs: "0.8rem",
                                    xl: "1rem",
                                },
                            }}
                        >
                            <Circle
                                sx={{
                                    paddingRight: "5px",
                                    "&.MuiSvgIcon-root": {
                                        color: "holiday.national",
                                    },
                                }}
                            />
                            National Holiday
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <>
                {!requestDays ? (
                    <Suspense
                        fallback={
                            <div
                                style={{
                                    textAlign: "center",
                                    marginTop: "25vh",
                                }}
                            >
                                <Dna
                                    visible={true}
                                    height="100"
                                    width="100"
                                    ariaLabel="dna-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="dna-wrapper"
                                />
                            </div>
                        }
                    >
                        <Box
                            sx={{
                                mt: {
                                    xs: 2,
                                    xl: 6,
                                },
                                width: "100%",
                            }}
                            className={"calendar_wrapper"}
                        >
                            <MonthCalendarCustom
                                nationalHolidays={nationalHolidays}
                                monthData={allListOfHolidays}
                            />
                        </Box>
                    </Suspense>
                ) : (
                    <Box sx={{ mt: 3, p: 1 }}>
                        <Divider textAlign="left" sx={{ mb: 2.5 }}>
                            <span style={{ fontWeight: 600 }}>
                                Fill Holiday Request
                            </span>
                        </Divider>
                        <div style={{ marginTop: 12, marginBottom: 12 }}>
                            <span style={{ color: "red", fontWeight: 600 }}>
                                Clients require annual leave to be announced 1
                                month prior to the leave. For shorter leave (a
                                few days), 1 week in advance.
                            </span>
                        </div>
                        <Box
                            sx={{
                                display: "flex",
                                [theme.breakpoints.down("sm")]: {
                                    flexDirection: "column",
                                },
                            }}
                        >
                            <Box>
                                <Box
                                    component="form"
                                    sx={{
                                        "& > :not(style)": {
                                            m: 1,
                                            mr: "0.6rem",
                                            width: "25ch",
                                        },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    {currentUser.role_id == ROLES.ADMIN ? (
                                        <FormControl
                                            style={{
                                                marginBottom: "12px",
                                                marginLeft: "8px",
                                            }}
                                        >
                                            <InputLabel
                                                shrink
                                                id="user-select-label"
                                            >
                                                Requesting User
                                            </InputLabel>
                                            <Select
                                                labelId="user-select-label"
                                                label="Select User"
                                                id="user-select"
                                                value={selectedRequestingUserId}
                                                onChange={async (e) => {
                                                    if (e.target.value) {
                                                        setSelectedRequestingUserId(
                                                            +e.target.value,
                                                        );
                                                    }
                                                }}
                                                style={{ minWidth: "200px" }}
                                            >
                                                {users.map((user) => (
                                                    <MenuItem
                                                        key={user.id}
                                                        value={user.id}
                                                    >
                                                        {user.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    ) : (
                                        <TextField
                                            id="outlined-basic"
                                            label="User"
                                            variant="outlined"
                                            value={currentUser.name}
                                        />
                                    )}

                                    <FormControl fullWidth>
                                        <InputLabel id="request type">
                                            Request Type
                                        </InputLabel>
                                        <Select
                                            label="Request Type"
                                            value={selectedOption}
                                            onChange={handleOptionChange}
                                        >
                                            {Object.keys(holidayTypes).map(
                                                (key) => (
                                                    <MenuItem
                                                        key={key}
                                                        value={key}
                                                    >
                                                        {key}
                                                    </MenuItem>
                                                ),
                                            )}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box>
                                    <RequestDaysForm
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        {isWide ? (
                                            <p
                                                style={{
                                                    paddingLeft: "12px",
                                                    paddingRight: "12px",
                                                }}
                                            >
                                                Select a Date Range
                                            </p>
                                        ) : (
                                            ""
                                        )}
                                        <RequestDaysComponent
                                            dateValue={dateValue}
                                            onChangeDateValue={
                                                onChangeDateValue
                                            }
                                        />
                                    </RequestDaysForm>
                                </Box>
                                <Box
                                    component="form"
                                    sx={{
                                        "& > :not(style)": {
                                            m: 1,
                                            width: "52ch",
                                            [theme.breakpoints.down("sm")]: {
                                                width: "25ch",
                                            },
                                        },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: 1,
                                            width: "100%",
                                        }}
                                    >
                                        <TextField
                                            id="approval-name"
                                            label="Approval Name"
                                            variant="outlined"
                                            required
                                            value={approvalName}
                                            onChange={(e) =>
                                                setApprovalName(e.target.value)
                                            }
                                            sx={{ flex: 1 }}
                                        />
                                        <TextField
                                            id="approval-date"
                                            label="Approval Date"
                                            variant="outlined"
                                            type="date"
                                            required
                                            value={approvalDate}
                                            onChange={(e) =>
                                                setApprovalDate(e.target.value)
                                            }
                                            InputLabelProps={{ shrink: true }}
                                            sx={{ flex: 1 }}
                                        />
                                        <TextField
                                            id="approval-via"
                                            label="Approval Via"
                                            variant="outlined"
                                            required
                                            value={approvalVia}
                                            onChange={(e) =>
                                                setApprovalVia(e.target.value)
                                            }
                                            sx={{ flex: 1 }}
                                        />
                                    </Box>
                                </Box>

                                <Box
                                    component="form"
                                    sx={{
                                        "& > :not(style)": {
                                            m: 1,
                                            mr: "0.6rem",
                                            width: "25ch",
                                        },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <TextField
                                        id="outlined-basic"
                                        label="Confirming"
                                        variant="outlined"
                                        value={requestApprover}
                                    />
                                </Box>
                                <Typography
                                    variant="body1"
                                    color="error"
                                    fontWeight="bold"
                                >
                                    {formError && <span>{formError}</span>}
                                </Typography>

                                <Button
                                    variant="contained"
                                    color="info"
                                    sx={{
                                        textTransform: "none",
                                        fontWeight: "600",
                                        m: 1,
                                    }}
                                    onClick={async () => {
                                        try {
                                            if (!selectedOption) {
                                                setFormError(
                                                    "Please select a holiday type.",
                                                );
                                                return;
                                            }

                                            if (dateValue.length < 2) {
                                                setFormError(
                                                    "Invalid date range. The start date cannot be after the end date.",
                                                );
                                                return;
                                            }

                                            if (
                                                !approvalName.trim() ||
                                                !approvalDate.trim() ||
                                                !approvalVia.trim()
                                            ) {
                                                setFormError(
                                                    "Please fill in both the Approval Name and Approval Date.",
                                                );
                                                return;
                                            }

                                            setFormError(""); // Clear any previous error

                                            const responseHoliday =
                                                await axiosInstance.post(
                                                    HOLIDAYS_URL,
                                                    formRequestHoliday,
                                                );
                                            const updatedHolidays: MonthDataParams[] =
                                                [
                                                    ...allListOfHolidays,
                                                    responseHoliday.data.data,
                                                ];
                                            setAllListOfHolidays(
                                                updatedHolidays,
                                            );
                                            setRequestDays(false);
                                            setDateValue([
                                                new DateObject(),
                                                new DateObject().add(4, "days"),
                                            ]);
                                            setApprovalName("");
                                            setApprovalDate("");
                                            window.location.reload();
                                        } catch (error) {
                                            const errorResponse = (
                                                error as {
                                                    request: {
                                                        response: string;
                                                    };
                                                }
                                            ).request.response;

                                            let errorMessage = "";

                                            if (
                                                errorResponse.includes(
                                                    "Selected dates are already requested for a holiday.",
                                                )
                                            ) {
                                                errorMessage =
                                                    "Selected dates are already requested for a holiday.";
                                            } else if (
                                                errorResponse.includes(
                                                    "The to date must be a date after or equal to from date",
                                                )
                                            ) {
                                                errorMessage =
                                                    "The to date must be a date after or equal to from date.";
                                            } else if (
                                                errorResponse.includes(
                                                    "The from date field is required",
                                                )
                                            ) {
                                                errorMessage =
                                                    "The from date field is required.";
                                            } else {
                                                errorMessage =
                                                    "An error occurred. Please try again later.";
                                            }

                                            setFormError(errorMessage);
                                        }
                                    }}
                                >
                                    Confirm
                                </Button>
                            </Box>
                            <Box
                                sx={{
                                    ml: 4,
                                    mt: 0.9,
                                    [theme.breakpoints.down("sm")]: {
                                        ml: "0",
                                    },
                                }}
                            >
                                <Box sx={{ display: "flex" }}>
                                    <RequestDaysCard
                                        cardColor={
                                            theme.palette.holiday.approved
                                        }
                                        cardType="workingDays"
                                        daysAvailable={
                                            isNaN(weekdays)
                                                ? "0"
                                                : (
                                                      weekdays - totalHolidays
                                                  ).toString()
                                        }
                                    />
                                    <RequestDaysCard
                                        cardColor={
                                            theme.palette.holiday.national
                                        }
                                        cardType="calendarDays"
                                        daysAvailable={
                                            isNaN(totalDays)
                                                ? "0"
                                                : totalDays.toString()
                                        }
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </>
        </>
    );
};
export default Holidays;
